import { PieceSlider, PieceDescription, PieceUnorderedList } from '@store/index';
const PUBLIC_URL = process.env.REACT_APP_URL;

const dietitian = {
    name: 'Dietitian',
    slug: 'dietitian',
    description: 'Rebuilding existing web application where doctors prescribe diet plan that helps users to track their diet, count calories, burn calories doing exercises, etc.',
    cover: {
        url: `${PUBLIC_URL}/portfolio/dietitian/cover.jpg`,
        license: {
            link: 'http://www.freepik.com',
            text: 'Designed by Freepik'
        }
    },
    prominentColor: 'rgb(195,149,108)',
    pieces: [
        {
            type: 'slider',
            images: [
                {
                    url: `${PUBLIC_URL}/portfolio/dietitian/dietician.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/dietitian/5.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by rawpixel.com / Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/dietitian/dietician-man.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/dietitian/health.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by rawpixel.com / Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/dietitian/plate.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/dietitian/cover.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Freepik'
                    }
                }
            ]
        } as PieceSlider,
        {
            type: 'description',
            title: 'Role',
            description: 'Back-End developer. Database administrator',
        } as PieceDescription,
        {
            type: 'unordered list',
            title: 'Main Technologies',
            items: ['JAVA', 'Spring', 'Postgres', 'tsvector'],
        } as PieceUnorderedList,
    ],
}

export default dietitian;


// WEBPACK FOOTER //
// ./src/store/portfolio/dietitian.tsx